<template>
  <div class="package-row">
    <div class="package-row-header bg-gray-light" @click="expanded = !expanded">
      <strong class="pkg-name">{{ pkg.packageId }}</strong>
      <span class="status">{{ lastStatus.statusText}}</span>
      <span class="datetime text-muted">{{ formatDate(lastStatus.dateAndTime)}}</span>
      <span class="actions">
        <i :class="{'icon-caret-down': !expanded, 'icon-caret-up': expanded}"></i>
      </span>
    </div>
    <StatusList class="ml-2 mt-2" v-show="expanded" :totalColli="totalColli" :statuses="pkg.packageStatuses" :maps="maps"/>
  </div>
</template>

<script>
import { dateFormat } from '@/utils'
import StatusList from './StatusList'

export default {
  props: {
    totalColli: {
      type: Number,
      required: true
    },
    pkg: {
      type: Object,
      required: true
    },
    maps: {
      type: Object
    }
  },
  data () {
    return {
      expanded: false
    }
  },
  computed: {
    lastStatus() {
      return this.pkg.packageStatuses[0]
    }
  },
  methods: {
    formatDate(dateTime) {
      return dateFormat(dateTime, {year: 'numeric', month: 'numeric', day: 'numeric'}) + ' - ' + dateFormat(dateTime, { hour: 'numeric', minute: 'numeric'})
    }
  },
  components: {
    StatusList
  }
}
</script>

<style scoped>
.text-muted {
  color: #AAAAAA;
}

.package-row {  
  margin-bottom: 10px;
}

.package-row-header {
  padding: 0.5rem 1rem;
}
.package-row-header,
.status-detail {
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.status-detail {
  border-bottom: 1px solid #f4f4f4;
}
.status-detail:hover {
  background-color: #f4f4f4;
}

.package-row-header:hover {
  background-color: #f4f4f4;
  cursor: pointer;
}

span.actions {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
}

i.icon-pin {
  font-size: 24px;
  position: relative;
  top: -4px;
  margin-bottom: -12px;
}

.map {
  height: 0;
  width: 100%;
}
.map.expanded {
  height: 250px;
}

@media(min-width: 1024px) {
  .package-row-header,
  .status-detail {
    flex-direction: row;
    justify-content: space-between;
  }

  .pkg-name {
    flex-basis: 25%;
  }

  span.status {
    flex-basis: auto;
    flex: 1;
  }

  span.datetime {
    flex-basis: 25%;
  }

  span.actions {
    width: 86px;
    margin-top: 0;
  }

  .map.expanded {
    height: 300px;
  }
}

</style>